(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/collections/match-list.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/collections/match-list.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.collections.Matchlist = Backbone.Collection.extend({
    log: new svs.core.log.Logger('svs.collections.Matchlist'),
    model: svs.tipset.models.Match,

    initialize: function() {
      this.listenTo(
        svs.tipset.models.play,
        'change',
        this.setDataFromLocalStorage
      );
      this.listenTo(
        svs.tipset.models.xpertenSystems,
        'add sync reset',
        this.setXpertBoardData
      );
      this.listenTo(
        svs.tipset.models.xpertenSystems,
        'generateSystem',
        this.clearXpertMarks
      );
      this.listenTo(
        svs.tipset.models.statistics,
        'changeFromStorage statisticsSet',
        this.setStatistics
      );
      this.on('buttonBet', this.save, this);
      this.on('currentMatchChanged', this.handleCurrentMatchChanged);

      this.parentId = 'svs-workarea-articles-gameanalyzestt';
      this.numOfArticles = '1';
    },

    setStatistics: function() {
      var statistics = svs.tipset.models.statistics.getStatistics();
      if (statistics.xpert) {
        this.getSpelanalys();
      }
    },

    getSpelanalys: function() {
      var urls = [];
      var self = this;
      var url;
      this.each(function(match) {
        var matchId = match.get('match').matchId;
        url = new svs.content.shared.ContentUrlBuilder('basicfilter')
          .addParams({
            parentId: self.parentId,
            domainCategories: 'svs-domain-sport-events/' + matchId,
            count: self.numOfArticles
          })
          .build();
        urls.push(encodeURIComponent(url));
      });
      svs.core.jupiter.get(urls, function(response) {
        self.each(function(match, index) {
          if (
            !response.responses[index].error &&
            response.responses[index].result.length &&
            response.responses[index].result[0].body
          ) {
            match.set(
              'spelanalys',
              new Handlebars.SafeString(
                response.responses[index].result[0].body
              )
            );
          }
        });
      });
    },

    setInitialMatch: function(options) {
      var matchNr = parseInt(options.eventNumber, 10) - 1;

      if (matchNr >= 0) {
        this.at(matchNr).setCurrentMatch(options.showMatchView);
      }
    },

    getNrOfHalfHedges: function() {
      var nrOfHalfHedges = 0;
      this.each(function(match) {
        if (match.getIsHalfHedge()) {
          nrOfHalfHedges++;
        }
      });

      return nrOfHalfHedges;
    },

    hasBomben: function() {
      var hasBomb = false;
      this.each(function(match) {
        if (!_.isUndefined(match.get('isBomben'))) hasBomb = true;
      });
      return hasBomb;
    },

    getNrOfFullHedges: function() {
      var nrOfFullHedges = 0;
      this.each(function(match) {
        if (match.getIsFullHedge()) {
          nrOfFullHedges++;
        }
      });

      return nrOfFullHedges;
    },

    getNrOfUMarks: function() {
      var nrOfUMarks = 0;
      this.each(function(match) {
        if (match.getIsU()) {
          nrOfUMarks++;
        }
      });

      return nrOfUMarks;
    },

    getBoardData: function() {
      var boardData = [];
      this.each(function(match) {
        boardData.push(match.getBoardData());
      });

      return boardData;
    },

    getWeights: function() {
      var weights = [];
      this.each(function(match) {
        weights.push(match.getWeights());
      });

      return weights;
    },

    getNrOfRows: function() {
      if (this.length === 0) {
        return 1;
      }

      var nrOfRows = 1,
        boardDataArr = this.getBoardData(),
        boardData,
        system = this.at(0).get('system'),
        i;
      if (system && system.type != 'SM' && system !== 'reduce-free') {
        for (i = 0; i < boardDataArr.length; i++) {
          boardData = boardDataArr[i];
          if (boardData === 15) {
            nrOfRows *= 3;
          } else if (boardData === 11 || boardData === 13 || boardData === 14) {
            nrOfRows *= 2;
          } else {
            nrOfRows *= 1;
          }
        }
      } else {
        for (i = 0; i < boardDataArr.length; i++) {
          boardData = boardDataArr[i];
          if (boardData === 7) {
            nrOfRows *= 3;
          } else if (boardData === 3 || boardData === 5 || boardData === 6) {
            nrOfRows *= 2;
          } else if (boardData === 1 || boardData === 2 || boardData === 4) {
            nrOfRows *= 1;
          } else {
            nrOfRows *= 1;
          }
        }
      }
      return nrOfRows;
    },

    isCorrect: function() {
      return _.indexOf(this.getBoardData(), 0) < 0;
    },

    getAllMatches: function() {
      return this.models;
    },

    isAnySet: function() {
      var isAnySet;

      isAnySet = _.some(this.models, function(match) {
        return match.hasMarks();
      });

      return isAnySet;
    },

    setDataFromLocalStorage: function(ev) {
      if (ev.isSingleRow) {
        this.reset();
      } else {
        var boardData = svs.utils.ns.isNamespace(
          'svs.tipset.objects.localstorageHandler.dataFromLocalStorage'
        )
          ? svs.tipset.objects.localstorageHandler.dataFromLocalStorage
            .boardData
          : undefined,
          uBoardData = svs.utils.ns.isNamespace(
            'svs.tipset.objects.localstorageHandler.dataFromLocalStorage'
          )
            ? svs.tipset.objects.localstorageHandler.dataFromLocalStorage
              .uRowData
            : undefined,
          baseRow = svs.utils.ns.isNamespace(
            'svs.tipset.objects.localstorageHandler.dataFromLocalStorage'
          )
            ? svs.tipset.objects.localstorageHandler.dataFromLocalStorage
              .baseRow
            : undefined,
          weights = svs.utils.ns.isNamespace(
            'svs.tipset.objects.localstorageHandler.dataFromLocalStorage'
          )
            ? svs.tipset.objects.localstorageHandler.dataFromLocalStorage
              .weights
            : undefined;

        if (uBoardData) {
          this.setUBoardDataFromLocalStorage(uBoardData);
        }

        if (boardData) {
          this.setBoardDataFromLocalStorage(boardData, baseRow);
        }

        if (weights) {
          this.setWeightDataFromLocalStorage(weights);
        }
      }
    },

    setBoardDataFromLocalStorage: function(boardData, baseRow) {
      this.each(function(match, index) {
        var baseRowData =
          baseRow && baseRow[index] ? baseRow[index] : undefined;
        if (boardData[index] != '0') {
          match.setMarkFromLocalStorage(boardData[index], baseRowData);
        }
      });
    },
    setWeightDataFromLocalStorage: function(weights) {
      this.each(function(match, index) {
        match.setWeightFromLocalStorage(weights[index]);
      });
    },
    setUBoardDataFromLocalStorage: function(uBoardData) {
      this.each(function(match, index) {
        match.setUMarkFromLocalStorage(uBoardData[index]);
      });
    },

    setXpertBoardData: function() {
      this.clearAll({
        isXpertWithBaseRow: svs.tipset.models.xpertenSystems.getUseBoardRow()
      });
      var boardData = svs.tipset.models.xpertenSystems.get('game1X2Boards')[0]
        .boardData;
      this.each(function(match, index) {
        match.setMarks(boardData[index]);
      });
      this.trigger('xpertBoardDataIsSet', this);
    },

    clearAll: function(options) {
      this.each(function(match) {
        match.clearAll(options);
      });
      this.trigger('resetAll');
      this.save();
    },

    getURowData: function() {
      var boardData = [];
      this.each(function(match) {
        boardData.push(match.getUBoardData());
      });

      return boardData;
    },

    save: function() {
      svs.tipset.objects.localstorageHandler.saveDataToLocalStorage();
    },

    getCurrentMatch: function() {
      return this.findWhere({ isCurrentMatch: true });
    },

    handleCurrentMatchChanged: function(options) {
      var allCurrentMatches = this.where({ isCurrentMatch: true }),
        navigateOptions = {
          trigger: svs.core.detect.formfactor.mobile(),
          replace: !svs.core.detect.formfactor.mobile()
        },
        currentCompetitionUrl = svs.tipset.models.competition
          ? svs.tipset.models.competition.getCompetitionUrl()
          : '',
        url;

      for (var i = 0; i < allCurrentMatches.length; i++) {
        if (allCurrentMatches[i].get('eventNumber') != options.eventNumber) {
          allCurrentMatches[i].set('isCurrentMatch', false);
        }
      }
      if (options.showMatchView) {
        if (svs.core.detect.formfactor.mobile()) {
          url = currentCompetitionUrl + options.matchLink;

          if (url.indexOf('?') === -1) {
            url += location.search;
          }
          svs.obj.router.navigate(url, navigateOptions);
        }
        this.trigger('currentMatchSet');
      }
    },

    getBaseRow: function() {
      var baseRow = [];

      if (this.getHasMarksSetByUser()) {
        this.each(function(match) {
          baseRow.push(match.getMarksByUser());
        });
      }

      return baseRow;
    },
    getHasMarksSetByUser: function() {
      var hasMarksSetByUser = 0;
      this.each(function(match) {
        if (match.hasMarksByUser()) {
          hasMarksSetByUser++;
        }
      });
      return hasMarksSetByUser > 0;
    },

    clearXpertMarks: function() {
      if (this.getHasMarksSetByUser()) {
        this.each(function(match) {
          match.removeXpertMarks();
        });
      } else {
        this.clearAll();
      }
    },

    getNrOfHalfHedgesSetByUser: function() {
      var nrOfHalfHedgesSetByUser = 0;
      this.each(function(match) {
        if (match.hasMarksByUser() && match.getIsHalfHedge()) {
          nrOfHalfHedgesSetByUser++;
        }
      });

      return nrOfHalfHedgesSetByUser;
    },

    getNrOfFullHedgesSetByUser: function() {
      var nrOfFullHedgesSetByUser = 0;
      this.each(function(match) {
        if (match.hasMarksByUser() && match.getIsFullHedge()) {
          nrOfFullHedgesSetByUser++;
        }
      });

      return nrOfFullHedgesSetByUser;
    },

    getIsHomeTeamByTeamId: function(teamId) {
      var isHomeTeam = false;

      this.each(function(match) {
        if (match.hasTeamId(teamId)) {
          isHomeTeam = match.isHomeTeam(teamId);
        }
      });
      return isHomeTeam;
    },

    resetCollection: function(drawEvents) {
      _.invoke(this.toArray(), 'destroy');
      this.reset(drawEvents);
    }
  });
})(Backbone, _, svs);

 })(window);